import * as B from '@blueprintjs/core';
import React from 'react';
import {useHistory} from 'react-router-dom';

import cs from 'app/components/Dashboard/Dashboard.styl';
import {makeUuidPrefix} from 'app/utils/routeUtils';

export const NoProjectsBlankstate: React.FC<{
  orgId: string;
}> = ({orgId}) => {
  const history = useHistory();
  const orgIdPrefix = makeUuidPrefix(orgId);

  return (
    <div className={cs.blankstate}>
      <B.NonIdealState
        icon={<B.Icon icon="control" size={120} />}
        title="Lens dashboard"
        description={
          <>
            <p>
              The Lens dashboard helps you track monitoring progress and trends across multiple
              properties—all in one place.
            </p>
            <p> Add a portfolio to get started.</p>
            <B.AnchorButton
              intent={B.Intent.PRIMARY}
              onClick={() => history.push(`/${orgIdPrefix}/admin/manageProperties`)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Add portfolio
            </B.AnchorButton>
          </>
        }
      />
    </div>
  );
};
